module.exports = __webpack_public_path__ + "static/media/edit-users-role.4cf95e5d.png";